import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Ignore DOM manipulation errors caused by browser extensions
    if (error?.message?.includes('removeChild') || error?.message?.includes('insertBefore')) {
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Silently ignore DOM manipulation errors from browser extensions
    if (error?.message?.includes('removeChild') || error?.message?.includes('insertBefore')) {
      return;
    }
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <h2 style={{ color: '#C62828', marginBottom: '12px' }}>Une erreur est survenue</h2>
          <p style={{ color: '#5E5F66', marginBottom: '20px' }}>
            {this.state.error?.message || 'Erreur inattendue'}
          </p>
          <button
            className="btn btn-primary"
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            data-testid="error-reload-btn"
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
